export default "__VITE_ASSET__Da$GgP$I__"